class ProductFormSticky extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback () {
    this.button = this.querySelector('.js-add-to-cart');
    this.quantityInput = this.querySelector('quantity-input');
    this.atcButton = document.querySelector('product-form button[type="submit"]');
    this.quantityForm = document.querySelector('.product-form__quantity quantity-input');
    this.quantityInputForm = this.quantityForm?.querySelector('input');
    this.sellingPlanOptions = this.querySelectorAll('.product-form-sticky__plan-option');
    this.sellingPlanInput = this.querySelector('.product-form-sticky__selling-plan-input');
    this.variantsDataEl = document.querySelector('[data-product-form-sticky-variants]');
    this.productFormId = this.dataset.productFormId;

    if (this._eventsAttached) return;
    this._eventsAttached = true;
    this.attachEvents();
  }

  attachEvents() {
    if (this.atcButton && this.button) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.atcButton.click();
      });
    }

    if (this.quantityInput && this.quantityInputForm) {
      this.quantityInput.addEventListener('change', (e) => {
        this.quantityInputForm.value = e.target.value;
        this.quantityInputForm.dispatchEvent(new Event('change'));
      });
    }

    this.sellingPlanOptions?.forEach((option) => {
      option.addEventListener('click', () => this.selectSellingPlan(option));
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectSellingPlan(option);
        }
      });
    });

    if (this.atcButton) {
      this._boundCheckOnViewport = this.checkOnViewport.bind(this);
      this.checkOnViewport();
      window.addEventListener('scroll', this._boundCheckOnViewport);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.variantChange) {
      this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.updateSellingPlansForVariant(event?.data?.variant?.id);
      });
    }
  }

  disconnectedCallback() {
    this.variantUnsub?.();
    if (this._boundCheckOnViewport) {
      window.removeEventListener('scroll', this._boundCheckOnViewport);
    }
  }

  checkOnViewport() {
    if (!this.atcButton) return;
    if (this.isElementInViewport(this.atcButton)) {
      this.classList.remove('is-show');
    } else {
      this.classList.add('is-show');
    }
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  selectSellingPlan(option) {
    const value = option.dataset.planValue ?? '';
    this.sellingPlanOptions?.forEach((o) => o.classList.remove('is-selected'));
    option.classList.add('is-selected');
    if (this.sellingPlanInput) this.sellingPlanInput.value = value;

    const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    sellingPlanInputs.forEach((input) => {
      input.value = value;
    });
  }

  updateSellingPlansForVariant(variantIdFromEvent) {
    if (!this.variantsDataEl || !this.sellingPlanOptions?.length) return;
    const data = JSON.parse(this.variantsDataEl.textContent);
    let variantId = variantIdFromEvent;
    if (variantId == null) {
      const variantIdInput = this.productFormId
        ? document.querySelector(`#${this.productFormId} input[name="id"]`)
        : document.querySelector('input.product-variant-id');
      variantId = variantIdInput?.value ? parseInt(variantIdInput.value, 10) : null;
    }
    if (!variantId || !data?.variants) return;
    const variant = data.variants.find((v) => v.id === variantId);
    if (!variant?.selling_plan_allocations?.length) return;
    const alloc = variant.selling_plan_allocations[0];
    const oneTime = this.querySelector('.product-form-sticky__plan-option[data-plan-value=""]');
    const subscribeOption = [...(this.querySelectorAll('.product-form-sticky__plan-option') || [])].find((o) => o.dataset.planValue !== '');
    const formatMoney = (cents) => {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      const fmt = data.money_format || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDec = Math.round(cents / 100);
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(amountNoDec).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };
    if (oneTime) oneTime.querySelector('[data-plan-price]').textContent = formatMoney(variant.price);
    if (subscribeOption) {
      const priceEl = subscribeOption.querySelector('[data-plan-price]');
      if (priceEl) {
        const compare = alloc.compare_at_price ?? variant.price;
        priceEl.innerHTML = `<span data-plan-original>${formatMoney(compare)}</span> <span data-plan-discount>${formatMoney(alloc.price)}</span>`;
      }
      subscribeOption.dataset.planValue = alloc.selling_plan_id;
    }
  }
}

customElements.define('product-form-sticky', ProductFormSticky);